<template>
  <div class="back-nav-bar">
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="onBack"
    />
  </div>
</template>

<script>
import { handleAppBack } from '../util/backNavigation'

export default {
  name: 'BackNavBar',
  props: {
    title: {
      type: String,
      default: '返回',
    },
  },
  methods: {
    onBack() {
      handleAppBack(this.$router)
    },
  },
}
</script>

<style scoped>
.back-nav-bar {
  flex-shrink: 0;
}
</style>
